<template>
  <div class="dash-scale-wrapper">
    <el-container class="page-container">
      <!-- 顶部导航栏 -->
    <el-header class="page-header">
      <div class="header-content">
        <span class="header-title" @click="handleTitleClick">智能考试系统</span>
        <!-- 用户信息下拉菜单 -->
        <el-dropdown @command="handleCommand" class="user-dropdown">
          <div class="user-info">
            <img :src="userAvatar" alt="头像" class="user-avatar" />
            <span class="user-name">{{ userName }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="isVip" disabled>
              <i class="el-icon-time"></i>
              {{ vipEndTimeText }}
            </el-dropdown-item>
            <el-dropdown-item command="logout">
              <i class="el-icon-switch-button"></i>
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>

    <!-- 主内容区域 -->
    <el-container class="main-container">
      <!-- 左侧职位列表 -->
      <el-aside width="400px" class="left-aside">
        <!-- 顶部标签栏 -->
        <div class="tab-card">
          <el-tabs v-model="activeTab" class="practice-tabs" @tab-click="handleTabClick" :before-leave="beforeTabLeave">
            <el-tab-pane name="free">
              <span slot="label" class="tab-label">
                <div class="tab-content">
                  <span class="tab-title" style="color: #3695F0">免费刷题</span>
                  <span class="tab-desc">2000题</span>
                </div>
              </span>
            </el-tab-pane>
            <el-tab-pane name="vip">
              <span slot="label" class="tab-label">
                <div class="tab-content">
                  <!-- <img
                    class="vip-icon"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng7b9a661db3ba64010a8db5e74981d2ed6f786f58dc92f01c3d67be8f581a324d.png"
                    alt="VIP"
                  /> -->
                  <div class="tab-text" @click="handleVipTabClick">
                    <span class="tab-title">VIP刷题</span>
                    <span class="tab-desc">精选200题</span>
                  </div>
                </div>
              </span>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!-- 职位列表 -->
        <el-card class="position-card" shadow="never">
          <div class="position-scrollbar">
            <div
              v-for="(position, index) in positionList"
              :key="index"
              class="position-item"
            >
              <div class="position-row">
                <span class="position-name">{{ position.name }}</span>
                <div class="position-actions">
                  <el-button
                    size="mini"
                    class="action-btn-outline"
                    @click="handleMockExam(position)"
                  >
                    模拟考试
                  </el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handlePractice(position)"
                  >
                    去刷题
                  </el-button>
                </div>
              </div>
              <el-divider v-if="index < positionList.length - 1" />
            </div>
          </div>
        </el-card>
      </el-aside>

      <!-- 右侧题目内容 -->
      <el-main class="main-content">
        <!-- 默认显示图片 -->
        <div v-if="!showQuestionContent" class="default-image-container">
          <img src="./assets/img/xztk.png" alt="选择题目" class="default-image" />
        </div>
        <!-- 题型标签栏和题目内容 -->
        <template v-else>
          <!-- 题型标签栏 -->
          <div class="question-type-tab-card">
            <el-tabs v-model="questionTypeTab" class="question-type-tabs">

              <el-tab-pane name="2">
                <span slot="label" class="tab-label">
                  <div class="tab-content">
                    <span class="tab-title">单选题</span>
                  </div>
                </span>
              </el-tab-pane>
              <el-tab-pane name="3">
                <span slot="label" class="tab-label">
                  <div class="tab-content">
                    <span class="tab-title">多选题</span>
                  </div>
                </span>
              </el-tab-pane>
              <el-tab-pane name="4">
                <span slot="label" class="tab-label">
                  <div class="tab-content">
                    <span class="tab-title">判断题</span>
                  </div>
                </span>
              </el-tab-pane>
              <el-tab-pane name="1">
                <span slot="label" class="tab-label">
                  <div class="tab-content">
                    <span class="tab-title">简答题</span>
                  </div>
                </span>
              </el-tab-pane>
            </el-tabs>
          </div>
        <el-card class="question-card" shadow="never" v-loading="loading">
          <div class="question-content" v-if="!loading && questionList.length > 0">
            <h2 class="question-title">{{ currentQuestion.title }}</h2>
            <div class="answer-section">
              <h3 class="answer-label">参考答案：</h3>
              <!-- 简答题 -->
              <template v-if="currentQuestion.type === 1">
                <!-- 刷题模式：直接显示答案 -->
                <template v-if="isStudyMode">
                  <div class="reference-answer">
                    <div class="reference-title">标准答案：</div>
                    <div class="reference-content">{{ currentQuestion.answer || '暂无参考答案' }}</div>
                  </div>
                </template>
                <!-- 答题模式：显示答题框，鼠标离开时显示答案 -->
                <template v-else>
                  <div class="user-answer-section">
                    <el-input
                      v-model="currentAnswer"
                      type="textarea"
                      :rows="10"
                      :maxlength="2000"
                      show-word-limit
                      placeholder="请输入您的答案"
                      class="answer-input"
                      @blur="handleAnswerBlur"
                    />
                  </div>
                  <div v-if="showAnswer" class="reference-answer">
                    <div class="reference-title">标准答案：</div>
                    <div class="reference-content">{{ currentQuestion.answer || '暂无参考答案' }}</div>
                  </div>
                </template>
              </template>
              <!-- 选择题：使用单选按钮 -->
              <el-radio-group
                v-else-if="currentQuestion.type === 2"
                v-model="currentAnswer"
                class="choice-options"
                :disabled="isStudyMode"
              >
                <el-radio
                  v-for="(option, index) in currentQuestionOptions"
                  :key="index"
                  :label="option.value"
                  class="choice-option"
                >
                  <span class="option-label">{{ option.label }}：</span>
                  <span class="option-content">{{ option.content }}</span>
                </el-radio>
              </el-radio-group>
              <!-- 多选题：使用复选框 -->
              <el-checkbox-group
                v-else-if="currentQuestion.type === 3"
                v-model="currentAnswer"
                class="choice-options"
                :disabled="isStudyMode"
              >
                <el-checkbox
                  v-for="(option, index) in currentQuestionOptions"
                  :key="index"
                  :label="option.value"
                  class="choice-option"
                >
                  <span class="option-label">{{ option.label }}：</span>
                  <span class="option-content">{{ option.content }}</span>
                </el-checkbox>
              </el-checkbox-group>
              <!-- 判断题：使用单选按钮，只有正确/错误两个选项 -->
              <el-radio-group
                v-else-if="currentQuestion.type === 4"
                v-model="currentAnswer"
                class="choice-options"
                :disabled="isStudyMode"
              >
                <el-radio
                  v-for="(option, index) in currentQuestionOptions"
                  :key="index"
                  :label="option.value"
                  class="choice-option"
                >
                  <span class="option-label">{{ option.label }}：</span>
                  <span class="option-content">{{ option.content }}</span>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="question-actions">
              <el-button
                :disabled="currentQuestionIndex === 0"
                @click="handlePrevQuestion"
              >
                上一题
              </el-button>
              <el-button
                type="primary"
                @click="handleNextQuestion"
              >
                下一题
              </el-button>
            </div>
          </div>
          <div v-else-if="!loading && questionList.length === 0" class="empty-tip">
            <p>暂无题目数据</p>
          </div>
        </el-card>
        </template>
      </el-main>
    </el-container>

    <!-- 支付二维码弹窗：append-to-body 避免被 dash-scale-wrapper 的 transform 层叠上下文影响，防止遮罩盖住弹窗 -->
    <el-dialog
      :visible.sync="showPaymentDialog"
      width="400px"
      append-to-body
      :close-on-click-modal="false"
      @close="handlePaymentDialogClose"
    >
      <div class="payment-content">
        <div class="payment-tip">请使用{{ payType === 1 ? '支付宝' : '微信' }}扫描下方二维码完成开通VIP</div>
        <!-- 支付方式选择 -->
        <div class="payment-type-selector">
          <el-radio-group v-model="payType" @change="handlePayTypeChange">
            <el-radio :label="1">支付宝</el-radio>
            <el-radio :label="3">微信</el-radio>
          </el-radio-group>
        </div>
        <div class="qr-code-container" v-loading="paymentLoading">
          <div v-if="qrCodeImageUrl" class="qr-code-image">
            <img :src="qrCodeImageUrl" alt="支付二维码" />
          </div>
          <div v-else class="qr-code-placeholder">
            <i class="el-icon-picture" style="font-size: 120px; color: #ccc;"></i>
            <p style="margin-top: 20px; color: #999;">加载中...</p>
          </div>
        </div>
        <div class="payment-amount">支付金额：¥{{ (paymentAmount / 100).toFixed(2) }} / 30天</div>
      </div>
    </el-dialog>
    </el-container>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getUserInfo as getUserInfoFromCache, setUserInfo, removeToken, removeUserInfo } from '@/utils/auth'
import { getUserInfo as getUserInfoApi, loginOut } from '@/api/login'

export default {
  name: 'ShuatiWeikaitong',
  props: {
    type: {
      type: [String, Number],
      default: '1'
    }
  },
  data() {
    return {
      activeTab: 'free',
      questionTypeTab: '2', // 题型标签栏激活状态
      currentQuestionIndex: 0,
      currentAnswer: '',
      positionList: [], // 职位列表，从后台接口获取
      currentCategory: '', // 当前选中的职位对应的 category
      questionList: [],
      loading: false,
      showAnswer: false, // 答题模式下，是否显示答案
      showPaymentDialog: false, // 支付二维码弹窗显示状态
      isInitializing: true, // 是否正在初始化，用于避免初始化时触发 watch
      showQuestionContent: false, // 是否显示题目内容，默认显示图片
      currentFreeType: null, // 当前选中的 freeType（0=免费，1=VIP）
      qrCodeImageUrl: '', // 支付二维码图片地址
      payType: 1, // 支付方式：1=支付宝，3=微信
      paymentLoading: false, // 支付二维码加载状态
      paymentAmount: 0, // 支付金额（单位：分）
      clientSn: '', // 支付订单号
      userInfo: null, // 用户信息
      payStatusTimer: null, // 支付状态轮询定时器
      payStatusPollCount: 0 // 支付状态轮询次数（最多100次，5分钟）
    };
  },
  computed: {
    // 判断是否为刷题模式（type=1为刷题模式，type=2为答题模式）
    isStudyMode() {
      return String(this.type) === '1'
    },
    currentQuestion() {
      return this.questionList[this.currentQuestionIndex] || {};
    },
    // 解析选择题选项（单选、多选和判断题共用）
    currentQuestionOptions() {
      // 判断题：固定返回正确/错误两个选项
      if (this.currentQuestion.type === 4) {
        return [
          { label: 'A', value: 'A', content: '正确' },
          { label: 'B', value: 'B', content: '错误' }
        ];
      }

      // 选择题（单选和多选）：解析答案格式
      if ((this.currentQuestion.type !== 2 && this.currentQuestion.type !== 3) || !this.currentQuestion.answer) {
        return [];
      }

      // 解析答案格式：A:内容1,B:内容2,C:内容3,D:内容4（内容中可含逗号，故在「,字母:」处分割）
      const contentStr = this.currentQuestion.content;
      const options = [];
      const parts = contentStr.split(/,(?=[A-Z]:)/);

      parts.forEach(part => {
        const match = part.match(/^([A-Z]):([\s\S]+)$/);
        if (match) {
          options.push({
            label: match[1],
            value: match[1],
            content: match[2].trim()
          });
        }
      });

      return options;
    },
    // 用户名
    userName() {
      if (this.userInfo && this.userInfo.user) {
        if (this.userInfo.user.nickname) {
          return this.userInfo.user.nickname
        }
        if (this.userInfo.user.username) {
          return this.userInfo.user.username
        }
      }
      return ''
    },
    // 用户头像
    userAvatar() {
      // 使用默认头像
      return require('./assets/img/default.png')
    },
    // 判断是否是 VIP
    isVip() {
      return this.userInfo && this.userInfo.user && this.userInfo.user.vipType === 1
    },
    // VIP 结束时间文本
    vipEndTimeText() {
      if (!this.isVip || !this.userInfo.user.vipEndTime) {
        return ''
      }
      // vipEndTime 是时间戳（毫秒），转换为日期字符串
      const date = new Date(this.userInfo.user.vipEndTime)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  },
  async mounted() {
    // 获取职位列表
    await this.fetchPositionList()
    // 获取个人信息并覆盖浏览器缓存数据
    await this.refreshUserInfo()
    // 加载用户信息
    this.loadUserInfo()
    // 页面初始化时不加载题目列表，等待用户点击"去刷题"按钮
    // 初始化完成，允许 watch 触发
    this.$nextTick(() => {
      this.isInitializing = false
    })
  },
  beforeDestroy() {
    // 组件销毁时停止轮询，避免内存泄漏
    this.stopPayStatusPolling()
  },
  watch: {
    currentQuestionIndex() {
      // 当题目索引变化时，更新当前答案
      this.showAnswer = false // 重置答案显示状态
      this.initCurrentAnswer()
    },
    questionTypeTab(newVal) {
      // 当题型标签切换时，重新获取对应题型的题目列表
      // 初始化阶段不触发，避免重复请求
      if (!this.isInitializing) {
        this.handleQuestionTypeChange(newVal)
      }
    },
    activeTab() {
      // 当免费和VIP切换时，隐藏题目内容，显示默认图片，清空题目列表
      this.showQuestionContent = false
      this.questionList = []
      this.currentQuestionIndex = 0
      this.currentAnswer = ''
      this.currentFreeType = null
    }
  },
  methods: {
    // 从后台获取职位列表
    async fetchPositionList() {
      try {
        const response = await request({
          url: '/system/data/getCategory',
          method: 'get'
        })

        // 处理返回的数据，转换为组件需要的格式
        // label -> name, value -> category
        if (response && Array.isArray(response)) {
          this.positionList = response.map(item => ({
            name: item.label,
            category: item.value
          }))
          // 如果职位列表不为空且 currentCategory 为空，设置默认的 category
          if (this.positionList.length > 0 && !this.currentCategory) {
            this.currentCategory = this.positionList[0].category
          }
        }
      } catch (error) {
        console.error('获取职位列表失败:', error)
        this.$message.error('获取职位列表失败，请稍后重试')
      }
    },
    // 从后台获取题库数据
    async fetchQuestionList(questionType = null, category = null, freeType = null) {
      try {
        this.loading = true
        // 使用传入的 category，如果没有传入则使用当前的 category
        const categoryValue = category || this.currentCategory
        const params = {
          category: categoryValue,
          type: '2' // 点击去刷题时，type 固定为 2
        }
        // 如果传入了题型参数，添加到请求参数中（使用 questionType 作为参数名）
        if (questionType !== null) {
          params.questionType = questionType
        }
        // 如果传入了 freeType 参数，添加到请求参数中（0=免费，1=VIP）
        if (freeType !== null) {
          params.freeType = freeType
        }
        const response = await request({
          url: '/system/data/list',
          method: 'get',
          params: params
        })

        // 处理返回的数据，转换为组件需要的格式
        if (response && Array.isArray(response)) {
          this.questionList = response.map(item => {
            // 根据题目类型初始化 userAnswer
            let userAnswer = ''
            if (item.type === 3) {
              // 多选题初始化为数组
              userAnswer = []
            }

            return {
              id: item.id,
              title: item.title,
              content: item.content,
              answer: item.answer,
              type: item.type,
              freeType: item.freeType,
              userAnswer: userAnswer
            }
          })
        }
      } catch (error) {
        console.error('获取题库数据失败:', error)
        // this.$message.error('获取题库数据失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    // 初始化当前题目的答案
    initCurrentAnswer() {
      if (this.questionList.length > 0) {
        const question = this.questionList[this.currentQuestionIndex] || this.questionList[0]
        if (question) {
          // 刷题模式：自动设置正确答案
          if (this.isStudyMode) {
            this.setCorrectAnswer(question)
          } else {
            // 答题模式：使用用户已保存的答案
            if (question.type === 3) {
              this.currentAnswer = Array.isArray(question.userAnswer)
                ? question.userAnswer
                : (question.userAnswer ? [question.userAnswer] : [])
            } else {
              this.currentAnswer = question.userAnswer || ''
            }
          }
        }
      }
    },
    // 设置正确答案（刷题模式使用）
    setCorrectAnswer(question) {
      if (!question || !question.answer) {
        return
      }

      const correctAnswer = String(question.answer || '').trim()

      // 多选题：需要解析为数组
      if (question.type === 3) {
        let correctAnswers = []
        if (correctAnswer.includes(':')) {
          // 格式为 "A:内容1,B:内容2"，提取选项字母
          const parts = correctAnswer.split(',')
          correctAnswers = parts.map(part => {
            const match = part.match(/^([A-Z])/)
            return match ? match[1] : part.trim()
          }).sort()
        } else {
          // 格式为 "A,B" 或 "A,B,C"
          correctAnswers = correctAnswer.split(',').map(a => a.trim()).sort()
        }
        this.currentAnswer = correctAnswers
      } else if (question.type === 4) {
        // 判断题：答案格式可能是 "A:正确,B:错误" 或 "A"
        if (correctAnswer.includes(':')) {
          const match = correctAnswer.match(/^([A-Z])/)
          this.currentAnswer = match ? match[1] : correctAnswer
        } else {
          this.currentAnswer = correctAnswer
        }
      } else if (question.type === 2) {
        // 单选题：答案格式可能是 "A:内容" 或 "A"
        if (correctAnswer.includes(':')) {
          const match = correctAnswer.match(/^([A-Z])/)
          this.currentAnswer = match ? match[1] : correctAnswer
        } else {
          this.currentAnswer = correctAnswer
        }
      } else {
        // 简答题：直接使用答案
        this.currentAnswer = correctAnswer
      }
    },
    // 处理题型切换
    async handleQuestionTypeChange(questionType) {
      // 重置题目索引和答案
      this.currentQuestionIndex = 0
      this.currentAnswer = ''
      this.showAnswer = false
      // 根据 activeTab 确定 freeType：free=0, vip=1
      const freeType = this.activeTab === 'vip' ? 1 : 0
      // 重新获取对应题型的题目列表，传入当前的 category 和 freeType
      await this.fetchQuestionList(questionType, this.currentCategory, freeType)
      // 初始化当前题目的答案
      this.initCurrentAnswer()
    },
    // 处理简答题输入框失去焦点事件（答题模式）
    handleAnswerBlur() {
      if (!this.isStudyMode && this.currentQuestion.type === 1) {
        this.showAnswer = true
      }
    },
    // eslint-disable-next-line no-unused-vars
    handleMockExam(position) {
      // 跳转到模拟考试页面
      this.$router.push('/exam/mock')

    },
    async handlePractice(position) {
      // 显示题目内容
      this.showQuestionContent = true
      // 获取职位对应的 category
      const category = position.category || '1'
      // 根据 activeTab 确定 freeType：free=0, vip=1
      const freeType = this.activeTab === 'vip' ? 1 : 0
      // 判断 category 或 freeType 是否发生变化
      const categoryChanged = this.currentCategory !== category
      const freeTypeChanged = this.currentFreeType !== freeType
      // 如果 category 或 freeType 发生变化，需要重新加载题目列表
      if (categoryChanged || freeTypeChanged) {
        if (categoryChanged) {
          this.currentCategory = category
        }
        if (freeTypeChanged) {
          this.currentFreeType = freeType
        }
        // 重置题目索引
        this.currentQuestionIndex = 0
        this.currentAnswer = ''
        this.showAnswer = false
      }
      // 如果还没有加载题目列表，或者 category/freeType 发生变化，或者之前隐藏了题目内容，则加载
      if (this.questionList.length === 0 || categoryChanged || freeTypeChanged) {
        await this.fetchQuestionList(this.questionTypeTab, category, freeType)
        // 根据第一题的题型设置题型标签栏
        if (this.questionList.length > 0 && this.questionList[0].type) {
          this.questionTypeTab = String(this.questionList[0].type)
        }
        // 初始化当前题目的答案
        this.initCurrentAnswer()
        // 初始化完成，允许 watch 触发
        this.$nextTick(() => {
          this.isInitializing = false
        })
      }
      
    },
    // 处理标题点击事件，跳转到首页
    handleTitleClick() {
      this.$router.push('/index')
    },
    // 刷新用户信息并覆盖浏览器缓存数据
    async refreshUserInfo() {
      try {
        const userInfo = await getUserInfoApi()
        if (userInfo) {
          setUserInfo(userInfo)
          this.userInfo = userInfo
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        // 静默失败，不影响用户体验
      }
    },
    // 加载用户信息
    loadUserInfo() {
      // 先从缓存获取
      const cachedUserInfo = getUserInfoFromCache()
      if (cachedUserInfo) {
        this.userInfo = cachedUserInfo
      }
      // 然后从接口获取最新信息
      this.refreshUserInfo()
    },
    // 处理下拉菜单命令
    handleCommand(command) {
      if (command === 'logout') {
        this.handleLogout()
      }
    },
    // 退出登录
    async handleLogout() {
      try {
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          // 调用退出接口
          try {
            await loginOut()
          } catch (error) {
            console.error('退出登录接口调用失败:', error)
          }

          // 清除本地存储
          removeToken()
          removeUserInfo()

          // 跳转到登录页
          this.$router.push('/login')
          this.$message.success('已退出登录')
        }).catch(() => {
          // 用户取消
        })
      } catch (error) {
        console.error('退出登录失败:', error)
      }
    },
    // 获取支付二维码
    async fetchPayInfo(payType = 1) {
      try {
        this.paymentLoading = true
        const response = await request({
          url: '/system/tk-order/getPayInfo',
          method: 'get',
          params: {
            payType: payType
          }
        })

        // 处理返回的数据
        if (response && response.qr_code_image_url) {
          this.qrCodeImageUrl = response.qr_code_image_url
          // 保存支付金额（单位：分）
          if (response.total_amount) {
            this.paymentAmount = Number(response.total_amount) || 0
          }
          // 保存订单号，用于轮询支付状态
          if (response.client_sn) {
            this.clientSn = response.client_sn
          }
        } else {
          this.$message.error('获取支付二维码失败')
        }
      } catch (error) {
        console.error('获取支付二维码失败:', error)
        this.$message.error('获取支付二维码失败，请稍后重试')
      } finally {
        this.paymentLoading = false
      }
    },
    // 处理标签切换前的验证
    beforeTabLeave(activeName) {
      // 如果切换到 VIP 标签，需要检查用户是否是 VIP
      if (activeName === 'vip') {
        const userInfo = getUserInfoFromCache()
        if (!userInfo) {
          this.$message.warning('请先登录')
          return false // 阻止切换
        }
        if (userInfo.user.vipType === 0) {
          // 不是 VIP，阻止切换，但会触发 handleVipTabClick 显示支付弹窗
          // 这里返回 false 阻止切换，但 handleVipTabClick 会处理支付逻辑
          return false
        }
      }
      // 其他情况允许切换
      return true
    },
    // 处理标签点击事件
    handleTabClick(tab) {
      // 如果点击的是 VIP 标签且用户不是 VIP，触发支付逻辑
      if (tab.name === 'vip') {
        const userInfo = getUserInfoFromCache()
        if (userInfo && userInfo.user.vipType === 0) {
          // 触发支付逻辑
          this.handleVipTabClick()
        }
      }
    },
    // 处理VIP标签点击事件（用于显示支付弹窗）
    async handleVipTabClick() {
      // 读取浏览器中的用户信息
      const userInfo = getUserInfoFromCache()
      if (!userInfo) {
        // 这个情况已经在 beforeTabLeave 中处理了
        return
      }
      // 检查 vipType 是否为 0（非 VIP 用户）
      if (userInfo.user.vipType === 0) {
        // 获取支付二维码（默认支付宝）
        this.payType = 1
        await this.fetchPayInfo(1)
        // 显示支付二维码弹窗
        this.showPaymentDialog = true
        // 开始轮询支付状态
        this.startPayStatusPolling()
      }
    },
    // 获取支付状态
    async fetchPayStatus() {
      if (!this.clientSn) {
        return
      }
      try {
        const response = await request({
          url: '/system/tk-order/getPayStatus',
          method: 'get',
          params: {
            clientSn: this.clientSn
          }
        })

        // data 中 1 代表支付成功，0 代表等待支付
        if (response === 1) {
          // 支付成功，停止轮询，关闭弹窗，重新获取用户信息
          this.stopPayStatusPolling()
          this.showPaymentDialog = false
          await this.refreshUserInfo()
          this.$message.success('支付成功！VIP激活成功！')
          // 切换到 VIP 标签
          this.activeTab = 'vip'
        }
        // response === 0 时继续轮询
      } catch (error) {
        console.error('获取支付状态失败:', error)
        // 轮询失败时不提示用户，继续轮询
      }
    },
    // 开始轮询支付状态
    startPayStatusPolling() {
      // 先停止之前的轮询
      this.stopPayStatusPolling()
      // 重置轮询次数
      this.payStatusPollCount = 0
      // 立即查询一次
      this.fetchPayStatus()
      // 每3秒轮询一次，持续5分钟（100次）
      this.payStatusTimer = setInterval(() => {
        this.payStatusPollCount++
        if (this.payStatusPollCount >= 100) {
          // 5分钟到了，停止轮询
          this.stopPayStatusPolling()
          return
        }
        this.fetchPayStatus()
      }, 3000)
    },
    // 停止轮询支付状态
    stopPayStatusPolling() {
      if (this.payStatusTimer) {
        clearInterval(this.payStatusTimer)
        this.payStatusTimer = null
      }
      this.payStatusPollCount = 0
    },
    // 处理支付方式切换
    async handlePayTypeChange(payType) {
      // 切换支付方式时，重新获取对应支付方式的二维码
      await this.fetchPayInfo(payType)
      // 重新开始轮询（因为 clientSn 可能变化）
      if (this.showPaymentDialog) {
        this.startPayStatusPolling()
      }
    },
    // 处理支付弹窗关闭事件
    async handlePaymentDialogClose() {
      // 停止轮询支付状态
      this.stopPayStatusPolling()
      // 清空二维码和支付金额，以便下次打开时重新加载
      this.qrCodeImageUrl = ''
      this.paymentAmount = 0
      this.clientSn = ''
      // 重新获取用户信息并覆盖浏览器缓存数据
      await this.refreshUserInfo()
    },
    handlePrevQuestion() {
      if (this.currentQuestionIndex > 0) {
        // 保存当前答案
        if (this.questionList[this.currentQuestionIndex]) {
          this.questionList[this.currentQuestionIndex].userAnswer = this.currentAnswer
        }
        this.currentQuestionIndex--
        // 加载上一题的答案（通过 watch 自动触发 initCurrentAnswer）
      }
    },
    // 检查答案是否正确
    checkAnswer() {
      const question = this.questionList[this.currentQuestionIndex]
      if (!question || !question.answer) {
        return true // 如果没有标准答案，认为正确
      }

      const correctAnswer = String(question.answer || '').trim()

      // 多选题：需要比较数组
      if (question.type === 3) {
        const userAnswer = Array.isArray(this.currentAnswer) ? this.currentAnswer : []
        // 多选题答案可能是 "A,B" 或 "A,B,C" 格式，也可能是 "A:内容1,B:内容2" 格式
        // 先尝试提取选项字母
        let correctAnswers = []
        if (correctAnswer.includes(':')) {
          // 格式为 "A:内容1,B:内容2"，提取选项字母
          const parts = correctAnswer.split(',')
          correctAnswers = parts.map(part => {
            const match = part.match(/^([A-Z])/)
            return match ? match[1] : part.trim()
          }).sort()
        } else {
          // 格式为 "A,B" 或 "A,B,C"
          correctAnswers = correctAnswer.split(',').map(a => a.trim()).sort()
        }
        const userAnswers = [...userAnswer].sort()
        return JSON.stringify(correctAnswers) === JSON.stringify(userAnswers)
      } else {
        // 单选题和判断题：直接比较字符串
        const userAnswer = String(this.currentAnswer || '').trim()
        // 如果答案格式为 "A:内容"，提取选项字母
        let correctAnswerValue = correctAnswer
        if (correctAnswer.includes(':')) {
          const match = correctAnswer.match(/^([A-Z])/)
          correctAnswerValue = match ? match[1] : correctAnswer
        }
        return userAnswer === correctAnswerValue
      }
    },
    async handleNextQuestion() {
      const question = this.questionList[this.currentQuestionIndex]
      const isLastQuestion = this.currentQuestionIndex === this.questionList.length - 1

      // 如果不是最后一题，执行正常的下一题逻辑
      if (!isLastQuestion) {
        // 答题模式下，如果是选择题（type=2,3,4），检查答案
        if (!this.isStudyMode && question && (question.type === 2 || question.type === 3 || question.type === 4)) {
          // 检查是否已选择答案
          if (question.type === 3) {
            // 多选题
            if (!this.currentAnswer || (Array.isArray(this.currentAnswer) && this.currentAnswer.length === 0)) {
              this.$message.warning('请先选择答案')
              return
            }
          } else {
            // 单选题和判断题
            if (!this.currentAnswer || this.currentAnswer === '') {
              this.$message.warning('请先选择答案')
              return
            }
          }

          // 检查答案是否正确
          const isCorrect = this.checkAnswer()

          if (!isCorrect) {
            // 答案错误，显示正确答案
            const correctAnswer = question.answer || '暂无标准答案'
            try {
              await this.$confirm(
                `您的答案错误！\n\n正确答案：${correctAnswer}\n\n请仔细查看正确答案后再继续。`,
                '答案错误',
                {
                  confirmButtonText: '我知道了',
                  cancelButtonText: '取消',
                  type: 'warning',
                  dangerouslyUseHTMLString: false
                }
              )
              // 用户点击确认，继续进入下一题
            } catch {
              // 用户点击取消，不进入下一题
              return
            }
          } else {
            // 答案正确，提示
            this.$message.success('答案正确！')
          }
        }

        // 保存当前答案
        if (question) {
          question.userAnswer = this.currentAnswer
        }
        this.currentQuestionIndex++
        // 加载下一题的答案（通过 watch 自动触发 initCurrentAnswer）
      } else {
        // 已经是最后一题，重新调用接口获取新题目
        // 先保存当前答案
        if (question) {
          question.userAnswer = this.currentAnswer
        }

        // 根据 activeTab 确定 freeType：free=0, vip=1
        const freeType = this.activeTab === 'vip' ? 1 : 0
        // 重新获取题目列表，传入当前题型、category 和 freeType
        await this.fetchQuestionList(this.questionTypeTab, this.currentCategory, freeType)

        // 重置索引为 0，并初始化答案
        this.currentQuestionIndex = 0
        this.initCurrentAnswer()

        // this.$message.success('已加载新题目')
      }
    }
  }
};
</script>

<style scoped lang="scss" src="./assets/index.scss" />
<style scoped lang="scss">
      .tab-content {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                height: 100%;
                padding-left: 59px;
                box-sizing: border-box;

                .tab-title {
                  font-size: 18px;
                  font-family: PingFangSC-Medium;
                  font-weight: 500;
                  color: rgba(27, 155, 113, 1);
                  line-height: 25px;
                  margin-bottom: 0;
                }

                .tab-desc {
                  font-size: 14px;
                  color: rgba(153, 153, 153, 1);
                  line-height: 20px;
                }
              }
               .is-active {
                background-color: rgba(27, 155, 113, 1);
                color: rgba(27, 155, 113, 1);
              }

.tab-text {
  cursor: pointer;
}

.payment-content {
  text-align: center;
  // padding: 20px 0;
}

.payment-tip {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.qr-code-placeholder {
  width: 250px;
  height: 250px;
  border: 2px dashed #ddd;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fafafa;
}

.payment-amount {
  font-size: 18px;
  font-weight: 500;
  color: #e6a23c;
  margin-top: 20px;
}

.payment-type-selector {
  display: flex;
  justify-content: center;
  margin: 20px 0;

  ::v-deep .el-radio-group {
    .el-radio {
      margin-right: 20px;

      .el-radio__label {
        font-size: 16px;
      }
    }
  }
}

.qr-code-image {
  width: 250px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #ddd;
  border-radius: 8px;
  background-color: #fff;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

</style>
